export const Overview = {
	URL: 'virtualPageURL',
	Title: 'virtualPageTitle',
};

export const Preview = {
	URL: 'virtualPageURL',
	Title: 'virtualPageTitle',
	ProgramName: 'coachProgNm',
	ProgramId: 'coachProgId',
};

export const Start = {
	ButtonText: 'buttonText',
	ProgramName: 'coachProgNm',
	ProgramId: 'coachProgId',
	Action: 'coachProgAction',
	ProgramStart: 'coachProgStart',
	ProgramEnd: 'coachProgEnd',
	ProgramDuration: 'coachProgDuration',
	Language: 'coachLanguage',
	LevelStatus: 'coachLevelStatus',
	LevelPoints: 'coachLevelPoints',
};
